import { SAVE_COMMENTS, SAVE_COMMENTS_SUCCESS, SAVE_COMMENTS_ERROR, SAVE_COMMENTS_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const SaveComments = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_COMMENTS:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case SAVE_COMMENTS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case SAVE_COMMENTS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case SAVE_COMMENTS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default SaveComments;
